// import React from 'react';
import { debugDispatcher } from '@apia/util';
// import { globals } from '../apps/types';

// type TWindowDDispatch = (action: string, ...parameters: unknown[]) => void;
export type TDispatchCallback = (parameters: unknown[]) => unknown;
// interface IStoredCallback {
//   (parameters: unknown[]): unknown;
//   help: () => void;
// }

// const debugDispatcher = new (class DDispatcher {
//   callbacks: Record<string, IStoredCallback[]> = {};

//   actions: Record<string, () => void> = {
//     shout: () => {
//       console.log(Object.keys(this.callbacks));
//     },
//   };

//   on(
//     action: string,
//     cb: TDispatchCallback,
//     help: string | React.ReactNode,
//     onlyDevelop = false,
//   ) {
//     if (globals?.getVersion()?.env === 'development' && onlyDevelop)
//       return () => {};

//     if (Object.keys(this.actions).includes(action))
//       throw new Error(
//         `The action ${action} is a reserved word for the dispatcher.`,
//       );
//     if (!this.callbacks[action]) this.callbacks[action] = [];
//     const actionMethod = Object.assign(cb, {
//       help: () => {
//         if (typeof help === 'string') console.info(help);
//       },
//     });
//     this.callbacks[action].push(actionMethod);
//     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//     // @ts-ignore
//     this[action] = Object.assign(
//       (...props: unknown[]) => {
//         this.emit(action, ...props);
//       },
//       {
//         help: () => {
//           if (typeof help === 'string') console.info(help);
//         },
//       },
//     );
//     return () => {
//       this.off(action, cb);
//     };
//   }

//   off(action: string, cb: TDispatchCallback) {
//     this.callbacks[action] = this.callbacks[action].filter(
//       (current) => current !== cb,
//     );
//   }

//   emit: TWindowDDispatch = (action, ...parameters) => {
//     if (this.actions[action]) this.actions[action]();
//     else {
//       if ((this.callbacks[action] ?? []).length === 1)
//         return this.callbacks[action]?.[0]?.(parameters);

//       (this.callbacks[action] ?? []).forEach((cb) => cb(parameters));
//     }
//     return null;
//   };
// })();

declare global {
  interface Window {
    dd: typeof debugDispatcher & Record<string, () => unknown>;
  }
}

window.dd = debugDispatcher as typeof debugDispatcher &
  Record<string, () => unknown>;

export default debugDispatcher;
